// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contenedor principal del sidebar */
.property-list-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: #fff;
}

/* Toolbar — dos filas iguales: estado|ayuda · ordenar|generar */
.property-list-toolbar {
  --pl-ctrl-h: 36px;
  --pl-ctrl-radius: 8px;
  --pl-ctrl-gap: 6px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: var(--pl-ctrl-gap);
  padding: 8px 10px;
  background: #fff;
  border-bottom: 1px solid #e8e4df;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  z-index: 2;
}

.property-list-toolbar__status {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: var(--pl-ctrl-gap);
  align-items: stretch;
  min-width: 0;
}

.property-list-help-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  height: var(--pl-ctrl-h);
  min-height: var(--pl-ctrl-h);
  padding: 0 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: var(--pl-ctrl-radius);
  background: #fff;
  color: #475569;
  font: inherit;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;
}

.property-list-help-trigger:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #0f172a;
}

.property-list-help-trigger .pi {
  font-size: 0.9rem;
  color: #fa7317;
}

.property-list-actions {
  display: flex;
  align-items: stretch;
  gap: 8px;
}

.property-list-actions .sort-dropdown.p-dropdown {
  flex: 1 1;
  min-width: 0;
}

.property-list-actions .property-report-container {
  flex: 1 1;
  min-width: 0;
  margin-bottom: 0;
  display: flex;
}

.property-list-actions .property-report-container .btn-generate-report {
  flex: 1 1;
  min-height: 36px;
  padding: 0.4rem 0.55rem;
  font-size: 0.78rem;
  white-space: nowrap;
}

/* Área scrolleable de cards */
.property-list-scroll {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 8px 12px 12px;
  -webkit-overflow-scrolling: touch;
}

.property-list {
  padding: 16px;
  overflow-y: auto;
  height: calc(100vh - 32px);
  max-width: 900px;
  margin: 0 auto;
}

/* Header del panel — legacy, ya no se usa en el markup */
.property-list-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 0;
}

.property-count-badge {
  display: flex;
  align-items: center;
  gap: 7px;
  height: var(--pl-ctrl-h, 36px);
  min-height: var(--pl-ctrl-h, 36px);
  box-sizing: border-box;
  border-radius: var(--pl-ctrl-radius, 8px);
  padding: 0 10px;
  border: 1px solid transparent;
}

.property-count-badge__main {
  display: flex;
  align-items: center;
  gap: 8px;
}

.property-count-badge__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 5px;
  flex-shrink: 0;
  font-size: 11px;
  background: transparent !important;
}

.property-count-badge__text {
  display: flex;
  flex-wrap: nowrap;
  align-items: baseline;
  gap: 0 6px;
  min-width: 0;
  line-height: 1.2;
  overflow: hidden;
}

.property-count-badge__count {
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.property-count-badge__legend {
  font-size: 11px;
  font-weight: 500;
  margin-left: 0.15rem;
}

.property-count-badge__hint {
  font-size: 11px;
  font-weight: 500;
  line-height: 1.2;
  opacity: 0.9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.property-count-badge__hint--ok {
  opacity: 0.85;
}

.property-count-badge--ok {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #065f46;
}

.property-count-badge--ok .property-count-badge__icon {
  color: #059669;
}

.property-count-badge--ok .property-count-badge__legend {
  color: #047857;
  font-weight: 500;
}

.property-count-badge--warning .property-count-badge__legend {
  color: inherit;
  opacity: 0.9;
}

.property-count-badge--warning {
  background: #fef2f2;
  border-color: #fecaca;
  color: #991b1b;
}

.property-count-badge--warning .property-count-badge__icon {
  color: #dc2626;
}

.property-count-badge--warning .property-count-badge__hint {
  color: #b91c1c;
}

/* Controles de la grilla: misma altura, bordes neutros; primario = generar */
.property-list-toolbar .sort-dropdown.p-dropdown,
.property-list-actions .sort-dropdown.p-dropdown {
  width: 100%;
  height: var(--pl-ctrl-h, 36px);
  min-height: var(--pl-ctrl-h, 36px);
  border: 1px solid #e2e8f0;
  border-radius: var(--pl-ctrl-radius, 8px);
  background: #fff;
  align-items: center;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
}

.property-list-toolbar .sort-dropdown.p-dropdown:not(.p-disabled):hover,
.property-list-actions .sort-dropdown.p-dropdown:not(.p-disabled):hover {
  border-color: #cbd5e1;
}

.property-list-toolbar .sort-dropdown.p-dropdown.p-focus,
.property-list-actions .sort-dropdown.p-dropdown.p-focus {
  border-color: #fa7317;
  box-shadow: 0 0 0 2px rgba(250, 115, 23, 0.12);
}

.property-list-toolbar .sort-dropdown .p-dropdown-label,
.property-list-actions .sort-dropdown .p-dropdown-label {
  display: flex;
  align-items: center;
  padding: 0 0.7rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #334155;
  line-height: 1;
}

.property-list-toolbar .sort-dropdown .p-dropdown-label.p-placeholder,
.property-list-actions .sort-dropdown .p-dropdown-label.p-placeholder {
  color: #64748b;
  font-weight: 500;
}

.property-list-toolbar .sort-dropdown .p-dropdown-trigger,
.property-list-actions .sort-dropdown .p-dropdown-trigger {
  color: #64748b;
  width: 2rem;
}

.property-list-header .sort-dropdown-panel.p-dropdown-panel,
.sort-dropdown-panel.p-dropdown-panel {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
}

.property-list-header .sort-dropdown-panel .p-dropdown-item.p-highlight,
.sort-dropdown-panel .p-dropdown-item.p-highlight {
  background: #fff8f4;
  color: #c2410c;
}

.property-list-header
  .sort-dropdown-panel
  .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover,
.sort-dropdown-panel .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover {
  background: #fff8f4;
  color: #9a3412;
}

/* Report: estimado arriba; ordenar + generar en la misma fila */
.property-report-container {
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  gap: var(--pl-ctrl-gap, 6px);
  min-width: 0;
}

.property-report-actions-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: var(--pl-ctrl-gap, 6px);
  align-items: stretch;
  min-width: 0;
}

.property-report-actions-row .sort-dropdown.p-dropdown,
.property-report-actions-row .btn-generate-report {
  width: 100%;
  min-width: 0;
}

.property-list-toolbar .acm-estimate-panel {
  margin: 0;
}

.property-report-container .btn-generate-report {
  width: 100%;
  height: var(--pl-ctrl-h, 36px);
  min-height: var(--pl-ctrl-h, 36px);
  justify-content: center;
  padding: 0 0.75rem;
  font-size: 0.75rem;
  font-weight: 700;
  border-radius: var(--pl-ctrl-radius, 8px);
  border: none;
  background: #fa7317;
  color: #fff;
  box-shadow: 0 1px 3px rgba(250, 115, 23, 0.25);
  transition:
    background 0.15s,
    box-shadow 0.15s,
    border-color 0.15s,
    color 0.15s;
}

.property-report-container .btn-generate-report:hover:not(:disabled) {
  background: #e06312;
  box-shadow: 0 2px 8px rgba(250, 115, 23, 0.35);
}

.property-report-container .btn-generate-report--blocked,
.property-report-container .btn-generate-report:disabled {
  background: #fff7ed;
  color: #c2410c;
  border: 1px solid #fdba74;
  box-shadow: none;
  opacity: 1;
  cursor: not-allowed;
}

/* Switch — ON verde / OFF gris (rápido) */
.property-active-switch {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 3px;
  border-radius: 999px;
  border: 1.5px solid #10b981;
  background: #ecfdf5;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  transition:
    background 0.12s ease,
    border-color 0.12s ease;
}

.property-active-switch--inactive {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.property-active-switch__track {
  display: inline-block;
  flex-shrink: 0;
  width: 34px;
  height: 18px;
  border-radius: 999px;
  background: #10b981;
  position: relative;
  transition: background 0.12s ease;
}

.property-active-switch--inactive .property-active-switch__track {
  background: #94a3b8;
}

.property-active-switch__thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  transform: translate3d(0, 0, 0);
  transition: transform 0.12s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
}

.property-active-switch:not(.property-active-switch--inactive)
  .property-active-switch__thumb {
  transform: translate3d(16px, 0, 0);
}

.button-report {
  background-color: #fa7317;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9em;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-right: 10px;
}

/* Tarjetas — on/off sutil: borde + tinte; el switch marca el estado */
.property-card {
  display: flex;
  gap: 12px;
  align-items: stretch;
  background: #fff;
  border-radius: 12px;
  margin: 0 auto 10px;
  box-shadow: none;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #e2e8f0;
  border-left: 3px solid #cbd5e1;
  max-width: 100%;
  padding: 10px;
  transition: none;
}
.property-card:hover {
  background: #fafafa;
  border-color: #cbd5e1;
}

/* Inactiva: neutra */
.property-card--inactive {
  background: #fff;
  border-left-color: #cbd5e1;
}

.property-card--inactive:hover {
  background: #fafafa;
  border-left-color: #94a3b8;
}

.property-card--inactive .property-price,
.property-list-scroll .property-card--inactive .property-price {
  color: #64748b;
}

/* Activa: tinte suave + borde marca (sin fill naranja ni texto blanco) */
.property-card--active,
.property-list .property-card.property-card--active,
.property-list-scroll .property-card.property-card--active {
  background: #fff7ed !important;
  border-color: #fed7aa;
  border-left-color: #fa7317;
  box-shadow: none;
  opacity: 1;
}

.property-card--active:hover,
.property-list .property-card.property-card--active:hover,
.property-list-scroll .property-card.property-card--active:hover {
  background: #ffedd5 !important;
  border-color: #fdba74;
  border-left-color: #ea580c;
}

.property-card--active .property-price,
.property-list-scroll .property-card--active .property-price {
  color: #ea580c;
}

.property-card--active .property-amenity {
  background: #fff;
  color: #c2410c;
  border-color: #fed7aa;
}

.property-thumbnail {
  align-self: start;
  object-fit: cover;
  border-radius: 9px;
  flex-shrink: 0;
  background: #f1f5f9;
}

.property-details {
  flex: 1 1;
  min-width: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
}

.property-card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.property-card-identity {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.property-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.property-address {
  flex: 1 1;
  min-width: 0;
  font-size: 13px;
  margin: 0;
  padding-right: 0;
  color: #0f172a;
  font-weight: 700;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}

.property-info {
  display: none;
}

.property-location {
  color: #64748b;
  margin: 0;
  font-size: 11px;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.property-list-scroll .property-price,
.property-card .property-price {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 8px;
  font-size: 16px;
  font-weight: 600;
  color: #fa7317;
  margin: -1px 0 0;
  line-height: 1.15;
  letter-spacing: -0.02em;
}

.property-price__value {
  white-space: nowrap;
}

.property-ppsqm {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 5px;
  margin: -1px 0 0;
  color: #334155;
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.01em;
}

.property-ppsqm__value {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.property-ppsqm__basis {
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
}

.property-card--inactive .property-ppsqm {
  color: #94a3b8;
}

.property-card--inactive .property-ppsqm__basis {
  color: #64748b;
}

.expenses {
  font-size: 0.72em;
  font-weight: 600;
  color: #64748b;
  margin-left: 0;
}

/* Specs en línea tipográfica — más densos y fáciles de escanear */
.property-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0;
  margin: 0;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
}

.property-meta span:not(:last-child)::after {
  content: "·";
  margin: 0 0.4em;
  color: #cbd5e1;
  font-weight: 700;
}

.property-amenities {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.property-amenity {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 999px;
  background: #fff8f4;
  color: #c2410c;
  border: 1px solid rgba(250, 115, 23, 0.28);
  font-size: 10.5px;
  font-weight: 600;
  line-height: 1.35;
}

/* Legacy chips (otras vistas / skeleton) */
.property-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 2px;
}
.property-chips.amenities {
  margin-top: 0;
}
.prop-chip {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px 8px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #334155;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.35;
}
.prop-chip i {
  font-size: 9px;
  color: #64748b;
}
.prop-chip.amen {
  background: #fff8f4;
  color: #c2410c;
  border: 1px solid rgba(250, 115, 23, 0.35);
}

.property-list-logo {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  background: white;
  padding: 20px 30px;
  border-radius: 8px;
  font-size: 16px;
  color: #333;
}
.property-list-logo .logo {
  max-width: 100px; /* Ajusta según sea necesario */
}

.exclude-property-button {
  position: relative;
  top: 8px;
  right: 0px;
  background: transparent;
  border: none;
  font-size: 24px;
  color: #fa7317;
  color: #fa7317;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  box-shadow: none;
  border-radius: 0;
}

/* Acciones de la card — CTAs compactos en fila. NO uso .details-button
   (esa clase la usan wizard/welcome). */
.property-actions {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 6px;
  padding: 8px 0 0;
  margin-top: auto;
  border-top: 1px solid #eef2f7;
}

.property-card-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background 0.12s ease,
    border-color 0.12s ease,
    color 0.12s ease;
}

.property-card-action .pi {
  font-size: 11px;
  flex-shrink: 0;
}

.property-card-action span {
  overflow: hidden;
  text-overflow: ellipsis;
}

.property-card-action--map:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #0f172a;
}

.property-card-action--pub {
  color: #c2410c;
  border-color: #fdba74;
  background: #fff7ed;
}

.property-card-action--pub:hover {
  background: #ffedd5;
  border-color: #fb923c;
  color: #9a3412;
}

.property-card--inactive .property-card-action,
.property-card--inactive .property-card-action--pub {
  color: #64748b;
  border-color: #e2e8f0;
  background: #fff;
}

.property-card--inactive .property-card-action:hover,
.property-card--inactive .property-card-action--pub:hover {
  color: #334155;
  border-color: #cbd5e1;
  background: #f8fafc;
}

.property-card--active .property-card-action--map {
  color: #c2410c;
  border-color: #fed7aa;
  background: #fff;
}

.property-card--active .property-card-action--map:hover {
  background: #fff7ed;
  border-color: #fdba74;
}

.property-card--active .property-card-action--pub {
  color: #c2410c;
  border-color: #fdba74;
  background: #fff;
}

.property-card--active .property-card-action--pub:hover {
  background: #ffedd5;
  border-color: #fb923c;
  color: #9a3412;
}

/* Legacy link class (por si queda en otro markup) */
.property-card-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0;
  border: none;
  background: transparent;
  font-weight: 600;
  font-size: 11.5px;
  font-family: inherit;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.15s ease;
  color: #fa7317;
  width: auto;
}
.property-card-link .pi {
  font-size: 10px;
}
.property-card-link:hover {
  color: #c2410c;
  text-decoration: underline;
}

/* Botón original — naranja de marca para Welcome/Wizard/etc. */
.details-button,
.publication-button {
  flex: 1 1;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9em;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}
.details-button {
  background-color: #fa7317;
  color: white;
  border: none;
  display: inline-block;
  padding: 8px 16px;
  width: auto;
  max-width: fit-content;
}
.details-button:hover {
  background-color: #c2410c;
}
.publication-button {
  background-color: #fff;
  color: #fa7317;
  border: 1px solid #fa7317;
}
.publication-button:hover {
  background-color: #f2f4ff;
}
.p-button-secondary {
  font-weight: 600;
  font-size: 0.9em;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  background-color: #fff;
  color: #fa7317;
  border: #fa7317 1px solid;
  padding: 8px 16px;
  width: auto;
  max-width: fit-content;
  margin-top: 1rem; /* Espaciado superior para los botones */
}
.p-button-secondary:hover {
  background-color: #e5e7eb;
}
.publication-button {
  background-color: #fff;
  color: #fa7317;
  border: 1px solid #fa7317;
}

.publication-button:hover {
  background-color: #f2f4ff;
}
.sort-dropdown {
  float: none;
}

.property-actions a {
  text-decoration: none;
}

.property-card.selected {
  border-color: #fdba74;
  box-shadow: 0 0 0 2px rgba(250, 115, 23, 0.2);
}

.property-card--active.selected {
  background: #fff7ed !important;
  border-color: #fdba74;
  border-left-color: #fa7317;
  box-shadow: 0 0 0 2px rgba(250, 115, 23, 0.2);
}

/* Skeleton Loader */
.skeleton {
  background: #f5f5f5;
  width: 560px;
  animation: skeleton-loading 1.5s infinite linear alternate;
}

.skeleton-box {
  background: #ddd;
  border-radius: 4px;
  animation: skeleton-loading 1.5s infinite linear alternate;
  width: 100%;
}

.skeleton-title {
  width: 100%;
  height: 16px;
  margin-bottom: 8px;
}

.skeleton-text {
  width: 100%;
  height: 12px;
  margin-bottom: 6px;
}

.skeleton-price {
  width: 60%;
  height: 18px;
  margin-top: 10px;
}

.report-buttons {
  padding: 20px;
}

/* Skeleton Animación */
@keyframes skeleton-loading {
  0% {
    background-color: #e0e0e0;
  }
  100% {
    background-color: #ebebeb;
  }
}
/* Estilos para el diálogo */
.report-dialog .p-dialog-header {
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.report-dialog .p-dialog-content {
  position: relative;
  padding: 1.5rem;
}

.dialog-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.dialog-loading-overlay p {
  margin-top: 1rem;
  color: #2c3e50;
  font-weight: 500;
}

.required-asterisk {
  color: #e74c3c;
  margin-left: 2px;
}

/* Efecto hover para los checkboxes */
.p-checkbox-label:hover {
  cursor: pointer;
  color: #2c3e50;
}

/* Ajustes para dispositivos móviles */
@media (max-width: 768px) {
  .report-dialog {
    width: 95vw !important;
  }

  .property-list-scroll {
    padding: 8px 10px 12px;
  }

  .property-list-toolbar {
    padding: 8px 10px 6px;
    gap: 6px;
  }

  .property-list-actions {
    gap: 6px;
  }

  .property-list {
    padding: 10px;
    height: auto;
  }

  .property-card {
    margin-bottom: 10px;
    max-width: 100%;
    padding: 8px;
    gap: 10px;
  }

  .property-details {
    padding: 0;
    gap: 4px;
  }

  .property-address {
    font-size: 12.5px !important;
  }

  .property-card-top,
  .property-card-header {
    gap: 8px;
  }

  .property-active-switch {
    padding: 2px;
  }

  .property-active-switch__track {
    width: 30px;
    height: 16px;
  }

  .property-active-switch__thumb {
    width: 12px;
    height: 12px;
  }

  .property-active-switch:not(.property-active-switch--inactive)
    .property-active-switch__thumb {
    transform: translate3d(14px, 0, 0);
  }

  .property-price {
    font-size: 15px !important;
  }

  .property-meta {
    font-size: 11px;
  }

  .property-amenity {
    font-size: 10px;
    padding: 2px 6px;
  }

  /* Sidebar de PrimeReact (Lista de Propiedades) ancho en mobile */
  .properties-sidebar.p-sidebar-right {
    width: 95vw !important;
    max-width: 95vw !important;
  }
}

@media (max-width: 480px) {
  .property-card {
    gap: 8px;
    padding: 8px;
  }

  .property-actions {
    gap: 5px;
  }

  .property-card-action {
    min-height: 30px;
    font-size: 11px;
    padding: 0 8px;
  }
}
/* Espaciado entre renglones */
.form-container > .col-12 {
  margin-bottom: 1.5rem; /* Espaciado entre renglones */
}

.form-container label {
  margin-bottom: 0.5rem; /* Espaciado entre el label y el input */
}

.form-container .flex {
  gap: 1rem; /* Espaciado entre elementos flexibles */
}

/* Botones */
.details-button {
  margin-top: 1rem; /* Espaciado superior para los botones */
  margin-right: 0.5rem; /* Espaciado horizontal entre botones */
}

.details-button:last-child {
  margin-right: 0; /* Elimina el margen derecho del último botón */
}
.error-message {
  text-align: center;
}

.property-list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  margin: 0 auto;
  padding: 32px 32px 56px;
  text-align: center;
}

.property-list-empty__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 14px;
  border: 1px solid rgba(250, 115, 23, 0.16);
  border-radius: 12px;
  background: linear-gradient(155deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 247, 237, 0.7) 100%);
  color: #c2410c;
  font-size: 22px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);
}

.property-list-empty h2,
.property-list-empty p {
  width: min(100%, 280px);
  margin-right: auto;
  margin-left: auto;
  text-align: center;
  text-wrap: balance;
}

.property-list-empty h2 {
  margin-top: 0;
  margin-bottom: 0;
  color: #0f172a;
  font-size: 16px;
  font-weight: 750;
  line-height: 1.3;
}

.property-list-empty p {
  margin-top: 8px;
  margin-bottom: 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.45;
}

/* Vista preliminar del informe — botón Excel con marca naranja */
.report-preview-btn-excel.p-button-outlined {
  color: #fa7317;
  border-color: #fa7317;
}

.report-preview-btn-excel.p-button-outlined:enabled:hover,
.report-preview-btn-excel.p-button-outlined:enabled:active {
  background: #fff8f4;
  color: #c2410c;
  border-color: #fa7317;
}

.report-preview-btn-excel.p-button-outlined:enabled:focus {
  box-shadow: 0 0 0 0.2rem rgba(250, 115, 23, 0.25);
}

.property-selection-guide {
  display: none; /* Reemplazada por drawer "Cómo elegir" */
}

/* Drawer de ayuda — misma lógica que wizard / welcome */
.comparable-help-drawer.p-sidebar {
  width: min(400px, 100vw);
  background: #fff;
  box-shadow: -12px 0 36px rgba(15, 23, 42, 0.12);
}

.comparable-help-drawer .p-sidebar-header {
  padding: 0.85rem 1rem 0;
  justify-content: flex-end;
}

.comparable-help-drawer .p-sidebar-content {
  padding: 0 1.25rem 1.5rem;
}

.comparable-help-drawer__body {
  text-align: left;
}

.comparable-help-drawer__header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.comparable-help-drawer__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  color: #c2410c;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  font-size: 1.1rem;
}

.comparable-help-drawer__eyebrow {
  margin: 0 0 0.1rem;
  color: #c2410c;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.comparable-help-drawer__title {
  margin: 0;
  color: #1f2937;
  font-size: 1.15rem;
  line-height: 1.25;
}

.comparable-help-drawer__lead {
  margin: 0 0 0.85rem;
  color: #374151;
  font-size: 0.95rem;
  line-height: 1.5;
}

.comparable-help-drawer__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 1rem;
}

.comparable-help-drawer__chips span {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  color: #334155;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  font-size: 0.72rem;
  font-weight: 700;
}

.comparable-help-drawer__steps {
  margin: 0;
  padding-left: 1.2rem;
  color: #4b5563;
  font-size: 0.92rem;
  line-height: 1.45;
}

.comparable-help-drawer__steps li + li {
  margin-top: 0.45rem;
}

.comparable-help-drawer__tip {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  margin-top: 1.15rem;
  padding-top: 1rem;
  border-top: 1px solid #fee2c5;
  color: #0f766e;
  font-size: 0.88rem;
  line-height: 1.4;
}

.comparable-help-drawer__tip .pi {
  margin-top: 0.1rem;
  flex-shrink: 0;
}

@media (max-width: 520px) {
  .comparable-help-drawer.p-sidebar {
    width: 100vw;
  }

  .property-list-help-trigger__label {
    display: none;
  }
}

@media (max-width: 420px) {
  .property-list-toolbar__status,
  .property-report-actions-row {
    grid-template-columns: 1fr;
  }
}

.property-selection-guide__close {
  position: absolute;
  top: 8px;
  right: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 6px;
  color: #64748b;
  background: transparent;
  cursor: pointer;
}

.property-selection-guide__close:hover {
  color: #0f172a;
  background: #e2e8f0;
}

.property-selection-guide__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.property-selection-guide__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  color: #c2410c;
  background: #fff7ed;
  border: 1px solid #fed7aa;
}

.property-selection-guide__header p {
  margin: 0 0 2px;
  color: #4338ca;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.property-selection-guide__header h3 {
  margin: 0;
  color: #0f172a;
  font-size: 0.94rem;
  line-height: 1.25;
}

.property-selection-guide__purpose {
  margin: 0 0 8px;
  color: #334155;
  font-size: 0.82rem;
  line-height: 1.4;
}

.property-selection-guide__steps {
  margin: 0;
  padding-left: 1.08rem;
  color: #475569;
  font-size: 0.78rem;
  line-height: 1.4;
}

.property-selection-guide__steps li + li {
  margin-top: 0.25rem;
}

.property-selection-guide__tip {
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #e2e8f0;
  color: #0f766e;
  font-size: 0.78rem;
  line-height: 1.35;
}

.property-list-toolbar > .property-report-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.acm-estimate-panel {
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 11px;
  border: 1px solid #f5d8bd;
  border-left: 4px solid #eaaa76;
  border-radius: 8px;
  background: #fffcf8;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.acm-estimate-panel--empty {
  border-color: #fed7aa;
  border-left-color: #fa7317;
  background: #fff7ed;
}

.acm-estimate-panel__header {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.acm-estimate-panel__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  border-radius: 7px;
  color: #a45a2a;
  background: #ffead6;
}

.acm-estimate-panel__header p {
  margin: 0 0 2px;
  color: #a45a2a;
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.acm-estimate-panel__header h3 {
  margin: 0;
  color: #0f172a;
  font-size: 0.92rem;
  line-height: 1.2;
}

.acm-estimate-panel__status {
  margin-left: auto;
  padding: 4px 7px;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 800;
  white-space: nowrap;
}

.acm-estimate-panel__status--ok {
  color: #047857;
  background: #d1fae5;
}

.acm-estimate-panel__status--warn {
  color: #92400e;
  background: #fef3c7;
}

.acm-estimate-panel__status--bad {
  color: #b91c1c;
  background: #fee2e2;
}

.acm-estimate-panel__main,
.acm-estimate-option {
  width: 100%;
  border: 1px solid transparent;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
}

.acm-estimate-panel__main:disabled,
.acm-estimate-option:disabled {
  cursor: not-allowed;
  opacity: 0.72;
}

.acm-estimate-panel__main {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 10px 11px;
  border-radius: 8px;
  color: #783d1e;
  background: linear-gradient(135deg, #fff0df 0%, #f9dfc5 100%);
  border-color: #efc6a1;
  box-shadow: 0 3px 10px rgba(180, 105, 50, 0.08);
}

.acm-estimate-panel__main:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(180, 105, 50, 0.14);
}

.acm-estimate-panel__main-label {
  font-size: 0.68rem;
  font-weight: 800;
  opacity: 0.82;
  text-transform: uppercase;
}

.acm-estimate-panel__main strong {
  font-size: 1.35rem;
  line-height: 1.1;
  letter-spacing: 0;
}

.acm-estimate-panel__main span:last-child {
  font-size: 0.76rem;
  opacity: 0.86;
}

.acm-estimate-panel__alternatives {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(124px, 1fr));
  gap: 7px;
}

.acm-estimate-option {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-height: 92px;
  padding: 9px;
  border-radius: 8px;
  background: #fff;
  border-color: #e2e8f0;
}

.acm-estimate-option:hover:not(:disabled) {
  border-color: #fa7317;
  box-shadow: 0 3px 10px rgba(250, 115, 23, 0.12);
}

.acm-estimate-option span {
  color: #334155;
  font-size: 0.72rem;
  font-weight: 800;
  text-transform: uppercase;
}

.acm-estimate-option strong {
  color: #0f172a;
  font-size: 0.95rem;
  line-height: 1.15;
}

.acm-estimate-option small {
  color: #64748b;
  font-size: 0.69rem;
  line-height: 1.25;
}

.acm-estimate-option--velocidad {
  border-left: 3px solid #0f766e;
}

.acm-estimate-option--respaldo {
  border-left: 3px solid #7c3aed;
}

.acm-estimate-option--margen {
  border-left: 3px solid #fa7317;
}

.acm-estimate-panel__details {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.acm-estimate-panel__details span {
  display: inline-flex;
  align-items: center;
  padding: 4px 7px;
  border-radius: 999px;
  color: #475569;
  background: #fff;
  border: 1px solid #e2e8f0;
  font-size: 0.68rem;
  font-weight: 700;
}

.acm-estimate-panel__text {
  margin: 0;
  color: #7c2d12;
  font-size: 0.78rem;
  line-height: 1.35;
}

.acm-estimate-panel__blocker {
  padding: 7px 9px;
  border-radius: 7px;
  color: #991b1b;
  background: #fee2e2;
  font-size: 0.76rem;
  font-weight: 700;
}

@media (max-width: 768px) {
  .acm-estimate-panel {
    padding: 10px;
  }

  .acm-estimate-panel__header {
    align-items: flex-start;
  }

  .acm-estimate-panel__status {
    margin-left: 0;
  }

  .acm-estimate-panel__main strong {
    font-size: 1.2rem;
  }
}
.report-preview-dialog .p-dialog-content {
  overflow: hidden;
}

.report-preview-actions-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 14px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
}

.report-preview-actions-bar__file {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.report-preview-actions-bar__file span {
  color: #64748b;
  font-size: 0.74rem;
  font-weight: 800;
  text-transform: uppercase;
  white-space: nowrap;
}

.report-preview-actions-bar__input.p-inputtext {
  width: 260px;
  max-width: 42vw;
  padding: 5px 8px;
  font-size: 0.78rem;
}

.report-preview-actions-bar__buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

@media (max-width: 1100px) {

  .report-preview-workspace {
    min-height: 420px !important;
  }
}

@media (max-width: 640px) {

  .report-preview-actions-bar,
  .report-preview-actions-bar__file {
    align-items: stretch;
    flex-direction: column;
  }

  .report-preview-actions-bar__input.p-inputtext,
  .report-preview-actions-bar__buttons {
    width: 100%;
    max-width: none;
  }

  .report-preview-actions-bar__buttons .p-button {
    flex: 1 1;
  }
}
/* Compact ACM sidebar and report modal */
.property-list-toolbar {
  gap: var(--pl-ctrl-gap, 6px);
  padding: 8px 10px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}

.property-count-badge__legend,
.property-count-badge__hint {
  font-size: 10.5px;
}

.property-report-container .btn-generate-report {
  min-height: var(--pl-ctrl-h, 36px);
  padding: 0 0.75rem;
  font-size: 0.75rem;
}

.acm-estimate-panel {
  gap: 6px;
  padding: 8px;
}

.acm-estimate-panel__header {
  gap: 7px;
}

.acm-estimate-panel__icon {
  flex-basis: 26px;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  font-size: 12px;
}

.acm-estimate-panel__header p {
  font-size: 0.6rem;
}

.acm-estimate-panel__header h3 {
  font-size: 0.8rem;
}

.acm-estimate-panel__status {
  padding: 3px 6px;
  font-size: 0.6rem;
}

.acm-estimate-panel__main {
  gap: 2px;
  padding: 7px 8px;
}

.acm-estimate-panel__main strong {
  font-size: 1.08rem;
}

.acm-estimate-panel__main span:last-child {
  font-size: 0.68rem;
}

.acm-estimate-panel__alternatives {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 5px;
}

.acm-estimate-option {
  min-height: 52px;
  padding: 6px;
  gap: 2px;
}

.acm-estimate-option span {
  font-size: 0.58rem;
}

.acm-estimate-option strong {
  font-size: 0.76rem;
}

.acm-estimate-option small,
.acm-estimate-panel__details span:nth-child(n + 3) {
  display: none;
}

.acm-estimate-panel__details {
  gap: 4px;
}

.acm-estimate-panel__details span {
  padding: 3px 6px;
  font-size: 0.62rem;
}

.property-selection-guide--compact {
  margin: 7px 10px 6px;
  padding: 8px 30px 8px 9px;
  box-shadow: none;
}

.property-selection-guide--compact .property-selection-guide__header {
  gap: 8px;
  margin-bottom: 6px;
}

.property-selection-guide--compact .property-selection-guide__icon {
  flex-basis: 28px;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  font-size: 12px;
}

.property-selection-guide--compact .property-selection-guide__header p {
  font-size: 0.58rem;
}

.property-selection-guide--compact .property-selection-guide__header h3 {
  font-size: 0.78rem;
}

.property-selection-guide__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.property-selection-guide__chips span {
  display: inline-flex;
  align-items: center;
  padding: 3px 6px;
  border-radius: 999px;
  color: #334155;
  background: #fff;
  border: 1px solid #e2e8f0;
  font-size: 0.62rem;
  font-weight: 700;
}

.property-list-scroll {
  padding: 7px 10px 12px;
  container: property-list / inline-size;
  scrollbar-gutter: stable;
  box-shadow: inset 0 8px 10px -12px rgba(15, 23, 42, 0.65);
}

.property-list-scroll::-webkit-scrollbar {
  width: 10px;
}

.property-list-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.property-list-scroll::-webkit-scrollbar-thumb {
  background: #fa7317;
  border: 2px solid #f1f5f9;
  border-radius: 999px;
}

.property-card {
  display: grid;
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1fr);
  gap: 10px;
  max-width: 100%;
  margin-bottom: 8px;
  padding: 9px;
  border-radius: 10px;
}

.property-thumbnail {
  display: block;
  width: 100%;
  height: auto;
  min-height: 0;
  aspect-ratio: 4 / 3;
  border-radius: 8px;
}

.property-card > .publication-details,
.property-card > .property-actions {
  grid-column: 1 / -1;
  margin-top: 0;
}

@container property-list (max-width: 420px) {
  .property-card {
    grid-template-columns: minmax(0, 1fr);
  }
}

.property-details {
  gap: 4px;
}

.property-address {
  font-size: 12.5px;
  line-height: 1.28;
  -webkit-line-clamp: 2;
}

.property-location {
  font-size: 10.5px;
}

.property-list-scroll .property-price,
.property-card .property-price {
  font-size: 15px;
  font-weight: 600;
  margin-top: 0;
}

.expenses {
  display: inline;
  margin-left: 0;
  font-size: 0.7em;
}

.property-meta {
  font-size: 11.5px;
}

.property-amenities {
  gap: 4px;
}

.property-amenity {
  padding: 2px 6px;
  font-size: 10px;
}

.property-actions {
  gap: 5px;
  padding-top: 7px;
  margin-top: auto;
}

.property-card-action {
  min-height: 30px;
  font-size: 11px;
}

.report-preview-actions-bar {
  padding: 6px 12px;
}

@media (max-width: 768px) {
  .property-card {
    gap: 8px;
    padding: 8px;
  }

  .acm-estimate-panel__alternatives {
    grid-template-columns: 1fr;
  }

  .acm-estimate-option small {
    display: block;
  }
}
.property-selection-guide__details {
  margin-top: 7px;
  border-top: 1px solid #e2e8f0;
  padding-top: 7px;
}

.property-selection-guide__details summary {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #b45309;
  font-size: 0.7rem;
  font-weight: 800;
  cursor: pointer;
  list-style: none;
}

.property-selection-guide__details summary::-webkit-details-marker {
  display: none;
}

.property-selection-guide__details summary i {
  font-size: 0.78rem;
}

.property-selection-guide__details[open] summary {
  margin-bottom: 6px;
}

.property-selection-guide__details ol {
  margin: 0;
  padding-left: 1.05rem;
  color: #475569;
  font-size: 0.72rem;
  line-height: 1.35;
}

.property-selection-guide__details li + li {
  margin-top: 0.18rem;
}

.property-selection-guide__details div {
  margin-top: 6px;
  padding: 6px 7px;
  border-radius: 6px;
  color: #0f766e;
  background: #ecfdf5;
  font-size: 0.7rem;
  line-height: 1.3;
}
/* Report modal must fit viewport without clipping Hornero */
.report-preview-dialog.p-dialog {
  height: 96vh !important;
  max-height: 96vh !important;
}

.report-preview-dialog .p-dialog-content {
  height: 100% !important;
  max-height: 100% !important;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
}

.report-preview-actions-bar {
  flex: 0 0 auto;
}

.report-preview-workspace {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  height: auto !important;
  max-height: none !important;
  overflow: hidden !important;
}

.report-preview-workspace > aside,
.report-preview-workspace > main {
  min-height: 0 !important;
  height: 100% !important;
  max-height: none !important;
}
/* Use the actual dialog header for report guidance */
.report-preview-dialog .p-dialog-header {
  flex: 0 0 auto;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 14px !important;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
}

.report-preview-dialog .p-dialog-title {
  flex: 1 1;
  min-width: 0;
}

.report-preview-dialog .p-dialog-header-icons {
  flex-shrink: 0;
  margin-top: 2px;
}

.report-preview-modal-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

.report-preview-modal-header__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  padding: 4px 7px;
  border-radius: 6px;
  color: #c2410c;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  font-size: 0.64rem;
  font-weight: 800;
  text-transform: uppercase;
}

.report-preview-modal-header__content {
  min-width: 0;
}

.report-preview-modal-header__content h2 {
  margin: 0;
  color: #0f172a;
  font-size: 0.95rem;
  line-height: 1.15;
  letter-spacing: 0;
}

.report-preview-modal-header__content p {
  margin: 2px 0 0;
  color: #475569;
  font-size: 0.74rem;
  line-height: 1.25;
}

.report-preview-modal-header__branding {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 5px;
  color: #7c2d12;
  font-size: 0.7rem;
  line-height: 1.2;
}

.report-preview-modal-header__branding i {
  color: #ea580c;
  font-size: 0.78rem;
  flex-shrink: 0;
}

.report-preview-modal-header__branding span {
  min-width: 0;
}

.report-preview-modal-header__branding a {
  color: #c2410c;
  font-weight: 800;
  text-decoration: none;
  white-space: nowrap;
}

.report-preview-modal-header__branding a:hover {
  text-decoration: underline;
}

@media (max-width: 780px) {
  .report-preview-modal-header,
  .report-preview-modal-header__branding {
    flex-wrap: wrap;
  }
}
.property-publisher {
  display: flex;
  align-items: baseline;
  gap: 5px;
  margin: 2px 0 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.35;
  overflow-wrap: anywhere;
}
.property-publisher i { flex-shrink: 0; font-size: 11px; }
.property-publisher__name {
  color: #1e293b;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/styles/PropertyList.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB;;;oBAGkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,yCAAyC;EACzC,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,6EAA6E;AAC7E;;EAEE,WAAW;EACX,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;EACnB;;oBAEkB;AACpB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,4BAA4B;EAC5B,oBAAoB;EACpB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,kCAAkC;EAClC,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,8CAA8C;EAC9C;;;;eAIa;AACf;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB;;2BAEyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;AAChB;;AAEA,yEAAyE;AACzE;;;EAGE,8BAA8B;EAC9B,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;EAGE,8BAA8B;EAC9B,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,MAAM;EACN,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;wCACwC;AACxC;EACE,aAAa;EACb,oDAAoD;EACpD,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB;;;oBAGkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;EACd,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,+DAA+D;AAC/D;;EAEE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,gBAAgB,EAAE,wCAAwC;AAC5D;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,YAAY;EACZ,0DAA0D;AAC5D;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0DAA0D;EAC1D,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;AACF;AACA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;;IAEE,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,iEAAiE;EACjE;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;AACF;AACA,8BAA8B;AAC9B;EACE,qBAAqB,EAAE,8BAA8B;AACvD;;AAEA;EACE,qBAAqB,EAAE,wCAAwC;AACjE;;AAEA;EACE,SAAS,EAAE,wCAAwC;AACrD;;AAEA,YAAY;AACZ;EACE,gBAAgB,EAAE,wCAAwC;EAC1D,oBAAoB,EAAE,uCAAuC;AAC/D;;AAEA;EACE,eAAe,EAAE,+CAA+C;AAClE;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,gGAAgG;EAChG,cAAc;EACd,eAAe;EACf,8CAA8C;AAChD;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,iEAAiE;AACjE;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa,EAAE,yCAAyC;AAC1D;;AAEA,wDAAwD;AACxD;EACE,wBAAwB;EACxB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,6DAA6D;EAC7D,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE;IACE,4BAA4B;EAC9B;AACF;;AAEA;;EAEE;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,SAAO;EACT;AACF;AACA,yCAAyC;AACzC;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,wBAAwB;EACxB,yDAAyD;AAC3D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;AACF;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA,4DAA4D;AAC5D;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA,qDAAqD;AACrD;EACE,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,4BAA4B;EAC5B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA,wBAAwB,cAAc,EAAE,eAAe,EAAE;AACzD;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Contenedor principal del sidebar */\n.property-list-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  background: #fff;\n}\n\n/* Toolbar — dos filas iguales: estado|ayuda · ordenar|generar */\n.property-list-toolbar {\n  --pl-ctrl-h: 36px;\n  --pl-ctrl-radius: 8px;\n  --pl-ctrl-gap: 6px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--pl-ctrl-gap);\n  padding: 8px 10px;\n  background: #fff;\n  border-bottom: 1px solid #e8e4df;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);\n  z-index: 2;\n}\n\n.property-list-toolbar__status {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: var(--pl-ctrl-gap);\n  align-items: stretch;\n  min-width: 0;\n}\n\n.property-list-help-trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  height: var(--pl-ctrl-h);\n  min-height: var(--pl-ctrl-h);\n  padding: 0 0.75rem;\n  border: 1px solid #e2e8f0;\n  border-radius: var(--pl-ctrl-radius);\n  background: #fff;\n  color: #475569;\n  font: inherit;\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.property-list-help-trigger:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.property-list-help-trigger .pi {\n  font-size: 0.9rem;\n  color: #fa7317;\n}\n\n.property-list-actions {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n}\n\n.property-list-actions .sort-dropdown.p-dropdown {\n  flex: 1;\n  min-width: 0;\n}\n\n.property-list-actions .property-report-container {\n  flex: 1;\n  min-width: 0;\n  margin-bottom: 0;\n  display: flex;\n}\n\n.property-list-actions .property-report-container .btn-generate-report {\n  flex: 1;\n  min-height: 36px;\n  padding: 0.4rem 0.55rem;\n  font-size: 0.78rem;\n  white-space: nowrap;\n}\n\n/* Área scrolleable de cards */\n.property-list-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 8px 12px 12px;\n  -webkit-overflow-scrolling: touch;\n}\n\n.property-list {\n  padding: 16px;\n  overflow-y: auto;\n  height: calc(100vh - 32px);\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n/* Header del panel — legacy, ya no se usa en el markup */\n.property-list-header {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 0;\n}\n\n.property-count-badge {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  height: var(--pl-ctrl-h, 36px);\n  min-height: var(--pl-ctrl-h, 36px);\n  box-sizing: border-box;\n  border-radius: var(--pl-ctrl-radius, 8px);\n  padding: 0 10px;\n  border: 1px solid transparent;\n}\n\n.property-count-badge__main {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.property-count-badge__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 5px;\n  flex-shrink: 0;\n  font-size: 11px;\n  background: transparent !important;\n}\n\n.property-count-badge__text {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: baseline;\n  gap: 0 6px;\n  min-width: 0;\n  line-height: 1.2;\n  overflow: hidden;\n}\n\n.property-count-badge__count {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.property-count-badge__legend {\n  font-size: 11px;\n  font-weight: 500;\n  margin-left: 0.15rem;\n}\n\n.property-count-badge__hint {\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.2;\n  opacity: 0.9;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.property-count-badge__hint--ok {\n  opacity: 0.85;\n}\n\n.property-count-badge--ok {\n  background: #ecfdf5;\n  border-color: #a7f3d0;\n  color: #065f46;\n}\n\n.property-count-badge--ok .property-count-badge__icon {\n  color: #059669;\n}\n\n.property-count-badge--ok .property-count-badge__legend {\n  color: #047857;\n  font-weight: 500;\n}\n\n.property-count-badge--warning .property-count-badge__legend {\n  color: inherit;\n  opacity: 0.9;\n}\n\n.property-count-badge--warning {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #991b1b;\n}\n\n.property-count-badge--warning .property-count-badge__icon {\n  color: #dc2626;\n}\n\n.property-count-badge--warning .property-count-badge__hint {\n  color: #b91c1c;\n}\n\n/* Controles de la grilla: misma altura, bordes neutros; primario = generar */\n.property-list-toolbar .sort-dropdown.p-dropdown,\n.property-list-actions .sort-dropdown.p-dropdown {\n  width: 100%;\n  height: var(--pl-ctrl-h, 36px);\n  min-height: var(--pl-ctrl-h, 36px);\n  border: 1px solid #e2e8f0;\n  border-radius: var(--pl-ctrl-radius, 8px);\n  background: #fff;\n  align-items: center;\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n}\n\n.property-list-toolbar .sort-dropdown.p-dropdown:not(.p-disabled):hover,\n.property-list-actions .sort-dropdown.p-dropdown:not(.p-disabled):hover {\n  border-color: #cbd5e1;\n}\n\n.property-list-toolbar .sort-dropdown.p-dropdown.p-focus,\n.property-list-actions .sort-dropdown.p-dropdown.p-focus {\n  border-color: #fa7317;\n  box-shadow: 0 0 0 2px rgba(250, 115, 23, 0.12);\n}\n\n.property-list-toolbar .sort-dropdown .p-dropdown-label,\n.property-list-actions .sort-dropdown .p-dropdown-label {\n  display: flex;\n  align-items: center;\n  padding: 0 0.7rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #334155;\n  line-height: 1;\n}\n\n.property-list-toolbar .sort-dropdown .p-dropdown-label.p-placeholder,\n.property-list-actions .sort-dropdown .p-dropdown-label.p-placeholder {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.property-list-toolbar .sort-dropdown .p-dropdown-trigger,\n.property-list-actions .sort-dropdown .p-dropdown-trigger {\n  color: #64748b;\n  width: 2rem;\n}\n\n.property-list-header .sort-dropdown-panel.p-dropdown-panel,\n.sort-dropdown-panel.p-dropdown-panel {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n}\n\n.property-list-header .sort-dropdown-panel .p-dropdown-item.p-highlight,\n.sort-dropdown-panel .p-dropdown-item.p-highlight {\n  background: #fff8f4;\n  color: #c2410c;\n}\n\n.property-list-header\n  .sort-dropdown-panel\n  .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover,\n.sort-dropdown-panel .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover {\n  background: #fff8f4;\n  color: #9a3412;\n}\n\n/* Report: estimado arriba; ordenar + generar en la misma fila */\n.property-report-container {\n  margin-bottom: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--pl-ctrl-gap, 6px);\n  min-width: 0;\n}\n\n.property-report-actions-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: var(--pl-ctrl-gap, 6px);\n  align-items: stretch;\n  min-width: 0;\n}\n\n.property-report-actions-row .sort-dropdown.p-dropdown,\n.property-report-actions-row .btn-generate-report {\n  width: 100%;\n  min-width: 0;\n}\n\n.property-list-toolbar .acm-estimate-panel {\n  margin: 0;\n}\n\n.property-report-container .btn-generate-report {\n  width: 100%;\n  height: var(--pl-ctrl-h, 36px);\n  min-height: var(--pl-ctrl-h, 36px);\n  justify-content: center;\n  padding: 0 0.75rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  border-radius: var(--pl-ctrl-radius, 8px);\n  border: none;\n  background: #fa7317;\n  color: #fff;\n  box-shadow: 0 1px 3px rgba(250, 115, 23, 0.25);\n  transition:\n    background 0.15s,\n    box-shadow 0.15s,\n    border-color 0.15s,\n    color 0.15s;\n}\n\n.property-report-container .btn-generate-report:hover:not(:disabled) {\n  background: #e06312;\n  box-shadow: 0 2px 8px rgba(250, 115, 23, 0.35);\n}\n\n.property-report-container .btn-generate-report--blocked,\n.property-report-container .btn-generate-report:disabled {\n  background: #fff7ed;\n  color: #c2410c;\n  border: 1px solid #fdba74;\n  box-shadow: none;\n  opacity: 1;\n  cursor: not-allowed;\n}\n\n/* Switch — ON verde / OFF gris (rápido) */\n.property-active-switch {\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n  padding: 3px;\n  border-radius: 999px;\n  border: 1.5px solid #10b981;\n  background: #ecfdf5;\n  pointer-events: none;\n  user-select: none;\n  transition:\n    background 0.12s ease,\n    border-color 0.12s ease;\n}\n\n.property-active-switch--inactive {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n.property-active-switch__track {\n  display: inline-block;\n  flex-shrink: 0;\n  width: 34px;\n  height: 18px;\n  border-radius: 999px;\n  background: #10b981;\n  position: relative;\n  transition: background 0.12s ease;\n}\n\n.property-active-switch--inactive .property-active-switch__track {\n  background: #94a3b8;\n}\n\n.property-active-switch__thumb {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: #fff;\n  transform: translate3d(0, 0, 0);\n  transition: transform 0.12s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);\n}\n\n.property-active-switch:not(.property-active-switch--inactive)\n  .property-active-switch__thumb {\n  transform: translate3d(16px, 0, 0);\n}\n\n.button-report {\n  background-color: #fa7317;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 0.9em;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-right: 10px;\n}\n\n/* Tarjetas — on/off sutil: borde + tinte; el switch marca el estado */\n.property-card {\n  display: flex;\n  gap: 12px;\n  align-items: stretch;\n  background: #fff;\n  border-radius: 12px;\n  margin: 0 auto 10px;\n  box-shadow: none;\n  overflow: hidden;\n  cursor: pointer;\n  border: 1px solid #e2e8f0;\n  border-left: 3px solid #cbd5e1;\n  max-width: 100%;\n  padding: 10px;\n  transition: none;\n}\n.property-card:hover {\n  background: #fafafa;\n  border-color: #cbd5e1;\n}\n\n/* Inactiva: neutra */\n.property-card--inactive {\n  background: #fff;\n  border-left-color: #cbd5e1;\n}\n\n.property-card--inactive:hover {\n  background: #fafafa;\n  border-left-color: #94a3b8;\n}\n\n.property-card--inactive .property-price,\n.property-list-scroll .property-card--inactive .property-price {\n  color: #64748b;\n}\n\n/* Activa: tinte suave + borde marca (sin fill naranja ni texto blanco) */\n.property-card--active,\n.property-list .property-card.property-card--active,\n.property-list-scroll .property-card.property-card--active {\n  background: #fff7ed !important;\n  border-color: #fed7aa;\n  border-left-color: #fa7317;\n  box-shadow: none;\n  opacity: 1;\n}\n\n.property-card--active:hover,\n.property-list .property-card.property-card--active:hover,\n.property-list-scroll .property-card.property-card--active:hover {\n  background: #ffedd5 !important;\n  border-color: #fdba74;\n  border-left-color: #ea580c;\n}\n\n.property-card--active .property-price,\n.property-list-scroll .property-card--active .property-price {\n  color: #ea580c;\n}\n\n.property-card--active .property-amenity {\n  background: #fff;\n  color: #c2410c;\n  border-color: #fed7aa;\n}\n\n.property-thumbnail {\n  align-self: start;\n  object-fit: cover;\n  border-radius: 9px;\n  flex-shrink: 0;\n  background: #f1f5f9;\n}\n\n.property-details {\n  flex: 1;\n  min-width: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  text-align: left;\n}\n\n.property-card-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.property-card-identity {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.property-card-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.property-address {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  margin: 0;\n  padding-right: 0;\n  color: #0f172a;\n  font-weight: 700;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-align: left;\n}\n\n.property-info {\n  display: none;\n}\n\n.property-location {\n  color: #64748b;\n  margin: 0;\n  font-size: 11px;\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.property-list-scroll .property-price,\n.property-card .property-price {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 2px 8px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #fa7317;\n  margin: -1px 0 0;\n  line-height: 1.15;\n  letter-spacing: -0.02em;\n}\n\n.property-price__value {\n  white-space: nowrap;\n}\n\n.property-ppsqm {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 5px;\n  margin: -1px 0 0;\n  color: #334155;\n  font-size: 12.5px;\n  font-weight: 600;\n  line-height: 1.2;\n  letter-spacing: -0.01em;\n}\n\n.property-ppsqm__value {\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.property-ppsqm__basis {\n  color: #475569;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0;\n}\n\n.property-card--inactive .property-ppsqm {\n  color: #94a3b8;\n}\n\n.property-card--inactive .property-ppsqm__basis {\n  color: #64748b;\n}\n\n.expenses {\n  font-size: 0.72em;\n  font-weight: 600;\n  color: #64748b;\n  margin-left: 0;\n}\n\n/* Specs en línea tipográfica — más densos y fáciles de escanear */\n.property-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0;\n  margin: 0;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.property-meta span:not(:last-child)::after {\n  content: \"·\";\n  margin: 0 0.4em;\n  color: #cbd5e1;\n  font-weight: 700;\n}\n\n.property-amenities {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.property-amenity {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 7px;\n  border-radius: 999px;\n  background: #fff8f4;\n  color: #c2410c;\n  border: 1px solid rgba(250, 115, 23, 0.28);\n  font-size: 10.5px;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n/* Legacy chips (otras vistas / skeleton) */\n.property-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  margin-top: 2px;\n}\n.property-chips.amenities {\n  margin-top: 0;\n}\n.prop-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #334155;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.35;\n}\n.prop-chip i {\n  font-size: 9px;\n  color: #64748b;\n}\n.prop-chip.amen {\n  background: #fff8f4;\n  color: #c2410c;\n  border: 1px solid rgba(250, 115, 23, 0.35);\n}\n\n.property-list-logo {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 10;\n}\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.loading-spinner {\n  background: white;\n  padding: 20px 30px;\n  border-radius: 8px;\n  font-size: 16px;\n  color: #333;\n}\n.property-list-logo .logo {\n  max-width: 100px; /* Ajusta según sea necesario */\n}\n\n.exclude-property-button {\n  position: relative;\n  top: 8px;\n  right: 0px;\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  color: #fa7317;\n  color: #fa7317;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n/* Acciones de la card — CTAs compactos en fila. NO uso .details-button\n   (esa clase la usan wizard/welcome). */\n.property-actions {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 6px;\n  padding: 8px 0 0;\n  margin-top: auto;\n  border-top: 1px solid #eef2f7;\n}\n\n.property-card-action {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-width: 0;\n  min-height: 32px;\n  padding: 0 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  text-decoration: none;\n  cursor: pointer;\n  white-space: nowrap;\n  transition:\n    background 0.12s ease,\n    border-color 0.12s ease,\n    color 0.12s ease;\n}\n\n.property-card-action .pi {\n  font-size: 11px;\n  flex-shrink: 0;\n}\n\n.property-card-action span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.property-card-action--map:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.property-card-action--pub {\n  color: #c2410c;\n  border-color: #fdba74;\n  background: #fff7ed;\n}\n\n.property-card-action--pub:hover {\n  background: #ffedd5;\n  border-color: #fb923c;\n  color: #9a3412;\n}\n\n.property-card--inactive .property-card-action,\n.property-card--inactive .property-card-action--pub {\n  color: #64748b;\n  border-color: #e2e8f0;\n  background: #fff;\n}\n\n.property-card--inactive .property-card-action:hover,\n.property-card--inactive .property-card-action--pub:hover {\n  color: #334155;\n  border-color: #cbd5e1;\n  background: #f8fafc;\n}\n\n.property-card--active .property-card-action--map {\n  color: #c2410c;\n  border-color: #fed7aa;\n  background: #fff;\n}\n\n.property-card--active .property-card-action--map:hover {\n  background: #fff7ed;\n  border-color: #fdba74;\n}\n\n.property-card--active .property-card-action--pub {\n  color: #c2410c;\n  border-color: #fdba74;\n  background: #fff;\n}\n\n.property-card--active .property-card-action--pub:hover {\n  background: #ffedd5;\n  border-color: #fb923c;\n  color: #9a3412;\n}\n\n/* Legacy link class (por si queda en otro markup) */\n.property-card-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  font-weight: 600;\n  font-size: 11.5px;\n  font-family: inherit;\n  cursor: pointer;\n  text-decoration: none;\n  transition: color 0.15s ease;\n  color: #fa7317;\n  width: auto;\n}\n.property-card-link .pi {\n  font-size: 10px;\n}\n.property-card-link:hover {\n  color: #c2410c;\n  text-decoration: underline;\n}\n\n/* Botón original — naranja de marca para Welcome/Wizard/etc. */\n.details-button,\n.publication-button {\n  flex: 1;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 0.9em;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n}\n.details-button {\n  background-color: #fa7317;\n  color: white;\n  border: none;\n  display: inline-block;\n  padding: 8px 16px;\n  width: auto;\n  max-width: fit-content;\n}\n.details-button:hover {\n  background-color: #c2410c;\n}\n.publication-button {\n  background-color: #fff;\n  color: #fa7317;\n  border: 1px solid #fa7317;\n}\n.publication-button:hover {\n  background-color: #f2f4ff;\n}\n.p-button-secondary {\n  font-weight: 600;\n  font-size: 0.9em;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  background-color: #fff;\n  color: #fa7317;\n  border: #fa7317 1px solid;\n  padding: 8px 16px;\n  width: auto;\n  max-width: fit-content;\n  margin-top: 1rem; /* Espaciado superior para los botones */\n}\n.p-button-secondary:hover {\n  background-color: #e5e7eb;\n}\n.publication-button {\n  background-color: #fff;\n  color: #fa7317;\n  border: 1px solid #fa7317;\n}\n\n.publication-button:hover {\n  background-color: #f2f4ff;\n}\n.sort-dropdown {\n  float: none;\n}\n\n.property-actions a {\n  text-decoration: none;\n}\n\n.property-card.selected {\n  border-color: #fdba74;\n  box-shadow: 0 0 0 2px rgba(250, 115, 23, 0.2);\n}\n\n.property-card--active.selected {\n  background: #fff7ed !important;\n  border-color: #fdba74;\n  border-left-color: #fa7317;\n  box-shadow: 0 0 0 2px rgba(250, 115, 23, 0.2);\n}\n\n/* Skeleton Loader */\n.skeleton {\n  background: #f5f5f5;\n  width: 560px;\n  animation: skeleton-loading 1.5s infinite linear alternate;\n}\n\n.skeleton-box {\n  background: #ddd;\n  border-radius: 4px;\n  animation: skeleton-loading 1.5s infinite linear alternate;\n  width: 100%;\n}\n\n.skeleton-title {\n  width: 100%;\n  height: 16px;\n  margin-bottom: 8px;\n}\n\n.skeleton-text {\n  width: 100%;\n  height: 12px;\n  margin-bottom: 6px;\n}\n\n.skeleton-price {\n  width: 60%;\n  height: 18px;\n  margin-top: 10px;\n}\n\n.report-buttons {\n  padding: 20px;\n}\n\n/* Skeleton Animación */\n@keyframes skeleton-loading {\n  0% {\n    background-color: #e0e0e0;\n  }\n  100% {\n    background-color: #ebebeb;\n  }\n}\n/* Estilos para el diálogo */\n.report-dialog .p-dialog-header {\n  background: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.report-dialog .p-dialog-content {\n  position: relative;\n  padding: 1.5rem;\n}\n\n.dialog-loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.9);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n}\n\n.dialog-loading-overlay p {\n  margin-top: 1rem;\n  color: #2c3e50;\n  font-weight: 500;\n}\n\n.required-asterisk {\n  color: #e74c3c;\n  margin-left: 2px;\n}\n\n/* Efecto hover para los checkboxes */\n.p-checkbox-label:hover {\n  cursor: pointer;\n  color: #2c3e50;\n}\n\n/* Ajustes para dispositivos móviles */\n@media (max-width: 768px) {\n  .report-dialog {\n    width: 95vw !important;\n  }\n\n  .property-list-scroll {\n    padding: 8px 10px 12px;\n  }\n\n  .property-list-toolbar {\n    padding: 8px 10px 6px;\n    gap: 6px;\n  }\n\n  .property-list-actions {\n    gap: 6px;\n  }\n\n  .property-list {\n    padding: 10px;\n    height: auto;\n  }\n\n  .property-card {\n    margin-bottom: 10px;\n    max-width: 100%;\n    padding: 8px;\n    gap: 10px;\n  }\n\n  .property-details {\n    padding: 0;\n    gap: 4px;\n  }\n\n  .property-address {\n    font-size: 12.5px !important;\n  }\n\n  .property-card-top,\n  .property-card-header {\n    gap: 8px;\n  }\n\n  .property-active-switch {\n    padding: 2px;\n  }\n\n  .property-active-switch__track {\n    width: 30px;\n    height: 16px;\n  }\n\n  .property-active-switch__thumb {\n    width: 12px;\n    height: 12px;\n  }\n\n  .property-active-switch:not(.property-active-switch--inactive)\n    .property-active-switch__thumb {\n    transform: translate3d(14px, 0, 0);\n  }\n\n  .property-price {\n    font-size: 15px !important;\n  }\n\n  .property-meta {\n    font-size: 11px;\n  }\n\n  .property-amenity {\n    font-size: 10px;\n    padding: 2px 6px;\n  }\n\n  /* Sidebar de PrimeReact (Lista de Propiedades) ancho en mobile */\n  .properties-sidebar.p-sidebar-right {\n    width: 95vw !important;\n    max-width: 95vw !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .property-card {\n    gap: 8px;\n    padding: 8px;\n  }\n\n  .property-actions {\n    gap: 5px;\n  }\n\n  .property-card-action {\n    min-height: 30px;\n    font-size: 11px;\n    padding: 0 8px;\n  }\n}\n/* Espaciado entre renglones */\n.form-container > .col-12 {\n  margin-bottom: 1.5rem; /* Espaciado entre renglones */\n}\n\n.form-container label {\n  margin-bottom: 0.5rem; /* Espaciado entre el label y el input */\n}\n\n.form-container .flex {\n  gap: 1rem; /* Espaciado entre elementos flexibles */\n}\n\n/* Botones */\n.details-button {\n  margin-top: 1rem; /* Espaciado superior para los botones */\n  margin-right: 0.5rem; /* Espaciado horizontal entre botones */\n}\n\n.details-button:last-child {\n  margin-right: 0; /* Elimina el margen derecho del último botón */\n}\n.error-message {\n  text-align: center;\n}\n\n.property-list-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 100%;\n  margin: 0 auto;\n  padding: 32px 32px 56px;\n  text-align: center;\n}\n\n.property-list-empty__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  margin-bottom: 14px;\n  border: 1px solid rgba(250, 115, 23, 0.16);\n  border-radius: 12px;\n  background: linear-gradient(155deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 247, 237, 0.7) 100%);\n  color: #c2410c;\n  font-size: 22px;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);\n}\n\n.property-list-empty h2,\n.property-list-empty p {\n  width: min(100%, 280px);\n  margin-right: auto;\n  margin-left: auto;\n  text-align: center;\n  text-wrap: balance;\n}\n\n.property-list-empty h2 {\n  margin-top: 0;\n  margin-bottom: 0;\n  color: #0f172a;\n  font-size: 16px;\n  font-weight: 750;\n  line-height: 1.3;\n}\n\n.property-list-empty p {\n  margin-top: 8px;\n  margin-bottom: 0;\n  color: #64748b;\n  font-size: 14px;\n  line-height: 1.45;\n}\n\n/* Vista preliminar del informe — botón Excel con marca naranja */\n.report-preview-btn-excel.p-button-outlined {\n  color: #fa7317;\n  border-color: #fa7317;\n}\n\n.report-preview-btn-excel.p-button-outlined:enabled:hover,\n.report-preview-btn-excel.p-button-outlined:enabled:active {\n  background: #fff8f4;\n  color: #c2410c;\n  border-color: #fa7317;\n}\n\n.report-preview-btn-excel.p-button-outlined:enabled:focus {\n  box-shadow: 0 0 0 0.2rem rgba(250, 115, 23, 0.25);\n}\n\n.property-selection-guide {\n  display: none; /* Reemplazada por drawer \"Cómo elegir\" */\n}\n\n/* Drawer de ayuda — misma lógica que wizard / welcome */\n.comparable-help-drawer.p-sidebar {\n  width: min(400px, 100vw);\n  background: #fff;\n  box-shadow: -12px 0 36px rgba(15, 23, 42, 0.12);\n}\n\n.comparable-help-drawer .p-sidebar-header {\n  padding: 0.85rem 1rem 0;\n  justify-content: flex-end;\n}\n\n.comparable-help-drawer .p-sidebar-content {\n  padding: 0 1.25rem 1.5rem;\n}\n\n.comparable-help-drawer__body {\n  text-align: left;\n}\n\n.comparable-help-drawer__header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.comparable-help-drawer__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 44px;\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  color: #c2410c;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  font-size: 1.1rem;\n}\n\n.comparable-help-drawer__eyebrow {\n  margin: 0 0 0.1rem;\n  color: #c2410c;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.comparable-help-drawer__title {\n  margin: 0;\n  color: #1f2937;\n  font-size: 1.15rem;\n  line-height: 1.25;\n}\n\n.comparable-help-drawer__lead {\n  margin: 0 0 0.85rem;\n  color: #374151;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.comparable-help-drawer__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 1rem;\n}\n\n.comparable-help-drawer__chips span {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 999px;\n  color: #334155;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.comparable-help-drawer__steps {\n  margin: 0;\n  padding-left: 1.2rem;\n  color: #4b5563;\n  font-size: 0.92rem;\n  line-height: 1.45;\n}\n\n.comparable-help-drawer__steps li + li {\n  margin-top: 0.45rem;\n}\n\n.comparable-help-drawer__tip {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  margin-top: 1.15rem;\n  padding-top: 1rem;\n  border-top: 1px solid #fee2c5;\n  color: #0f766e;\n  font-size: 0.88rem;\n  line-height: 1.4;\n}\n\n.comparable-help-drawer__tip .pi {\n  margin-top: 0.1rem;\n  flex-shrink: 0;\n}\n\n@media (max-width: 520px) {\n  .comparable-help-drawer.p-sidebar {\n    width: 100vw;\n  }\n\n  .property-list-help-trigger__label {\n    display: none;\n  }\n}\n\n@media (max-width: 420px) {\n  .property-list-toolbar__status,\n  .property-report-actions-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.property-selection-guide__close {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: none;\n  border-radius: 6px;\n  color: #64748b;\n  background: transparent;\n  cursor: pointer;\n}\n\n.property-selection-guide__close:hover {\n  color: #0f172a;\n  background: #e2e8f0;\n}\n\n.property-selection-guide__header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.property-selection-guide__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 36px;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  color: #c2410c;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n}\n\n.property-selection-guide__header p {\n  margin: 0 0 2px;\n  color: #4338ca;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0;\n  text-transform: uppercase;\n}\n\n.property-selection-guide__header h3 {\n  margin: 0;\n  color: #0f172a;\n  font-size: 0.94rem;\n  line-height: 1.25;\n}\n\n.property-selection-guide__purpose {\n  margin: 0 0 8px;\n  color: #334155;\n  font-size: 0.82rem;\n  line-height: 1.4;\n}\n\n.property-selection-guide__steps {\n  margin: 0;\n  padding-left: 1.08rem;\n  color: #475569;\n  font-size: 0.78rem;\n  line-height: 1.4;\n}\n\n.property-selection-guide__steps li + li {\n  margin-top: 0.25rem;\n}\n\n.property-selection-guide__tip {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.4rem;\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid #e2e8f0;\n  color: #0f766e;\n  font-size: 0.78rem;\n  line-height: 1.35;\n}\n\n.property-list-toolbar > .property-report-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.acm-estimate-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n  padding: 11px;\n  border: 1px solid #f5d8bd;\n  border-left: 4px solid #eaaa76;\n  border-radius: 8px;\n  background: #fffcf8;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n}\n\n.acm-estimate-panel--empty {\n  border-color: #fed7aa;\n  border-left-color: #fa7317;\n  background: #fff7ed;\n}\n\n.acm-estimate-panel__header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.acm-estimate-panel__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 32px;\n  width: 32px;\n  height: 32px;\n  border-radius: 7px;\n  color: #a45a2a;\n  background: #ffead6;\n}\n\n.acm-estimate-panel__header p {\n  margin: 0 0 2px;\n  color: #a45a2a;\n  font-size: 0.66rem;\n  font-weight: 800;\n  letter-spacing: 0;\n  text-transform: uppercase;\n}\n\n.acm-estimate-panel__header h3 {\n  margin: 0;\n  color: #0f172a;\n  font-size: 0.92rem;\n  line-height: 1.2;\n}\n\n.acm-estimate-panel__status {\n  margin-left: auto;\n  padding: 4px 7px;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.acm-estimate-panel__status--ok {\n  color: #047857;\n  background: #d1fae5;\n}\n\n.acm-estimate-panel__status--warn {\n  color: #92400e;\n  background: #fef3c7;\n}\n\n.acm-estimate-panel__status--bad {\n  color: #b91c1c;\n  background: #fee2e2;\n}\n\n.acm-estimate-panel__main,\n.acm-estimate-option {\n  width: 100%;\n  border: 1px solid transparent;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.acm-estimate-panel__main:disabled,\n.acm-estimate-option:disabled {\n  cursor: not-allowed;\n  opacity: 0.72;\n}\n\n.acm-estimate-panel__main {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  padding: 10px 11px;\n  border-radius: 8px;\n  color: #783d1e;\n  background: linear-gradient(135deg, #fff0df 0%, #f9dfc5 100%);\n  border-color: #efc6a1;\n  box-shadow: 0 3px 10px rgba(180, 105, 50, 0.08);\n}\n\n.acm-estimate-panel__main:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(180, 105, 50, 0.14);\n}\n\n.acm-estimate-panel__main-label {\n  font-size: 0.68rem;\n  font-weight: 800;\n  opacity: 0.82;\n  text-transform: uppercase;\n}\n\n.acm-estimate-panel__main strong {\n  font-size: 1.35rem;\n  line-height: 1.1;\n  letter-spacing: 0;\n}\n\n.acm-estimate-panel__main span:last-child {\n  font-size: 0.76rem;\n  opacity: 0.86;\n}\n\n.acm-estimate-panel__alternatives {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(124px, 1fr));\n  gap: 7px;\n}\n\n.acm-estimate-option {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-height: 92px;\n  padding: 9px;\n  border-radius: 8px;\n  background: #fff;\n  border-color: #e2e8f0;\n}\n\n.acm-estimate-option:hover:not(:disabled) {\n  border-color: #fa7317;\n  box-shadow: 0 3px 10px rgba(250, 115, 23, 0.12);\n}\n\n.acm-estimate-option span {\n  color: #334155;\n  font-size: 0.72rem;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.acm-estimate-option strong {\n  color: #0f172a;\n  font-size: 0.95rem;\n  line-height: 1.15;\n}\n\n.acm-estimate-option small {\n  color: #64748b;\n  font-size: 0.69rem;\n  line-height: 1.25;\n}\n\n.acm-estimate-option--velocidad {\n  border-left: 3px solid #0f766e;\n}\n\n.acm-estimate-option--respaldo {\n  border-left: 3px solid #7c3aed;\n}\n\n.acm-estimate-option--margen {\n  border-left: 3px solid #fa7317;\n}\n\n.acm-estimate-panel__details {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.acm-estimate-panel__details span {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 7px;\n  border-radius: 999px;\n  color: #475569;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  font-size: 0.68rem;\n  font-weight: 700;\n}\n\n.acm-estimate-panel__text {\n  margin: 0;\n  color: #7c2d12;\n  font-size: 0.78rem;\n  line-height: 1.35;\n}\n\n.acm-estimate-panel__blocker {\n  padding: 7px 9px;\n  border-radius: 7px;\n  color: #991b1b;\n  background: #fee2e2;\n  font-size: 0.76rem;\n  font-weight: 700;\n}\n\n@media (max-width: 768px) {\n  .acm-estimate-panel {\n    padding: 10px;\n  }\n\n  .acm-estimate-panel__header {\n    align-items: flex-start;\n  }\n\n  .acm-estimate-panel__status {\n    margin-left: 0;\n  }\n\n  .acm-estimate-panel__main strong {\n    font-size: 1.2rem;\n  }\n}\n.report-preview-dialog .p-dialog-content {\n  overflow: hidden;\n}\n\n.report-preview-actions-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 8px 14px;\n  background: #fff;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.report-preview-actions-bar__file {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.report-preview-actions-bar__file span {\n  color: #64748b;\n  font-size: 0.74rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.report-preview-actions-bar__input.p-inputtext {\n  width: 260px;\n  max-width: 42vw;\n  padding: 5px 8px;\n  font-size: 0.78rem;\n}\n\n.report-preview-actions-bar__buttons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n@media (max-width: 1100px) {\n\n  .report-preview-workspace {\n    min-height: 420px !important;\n  }\n}\n\n@media (max-width: 640px) {\n\n  .report-preview-actions-bar,\n  .report-preview-actions-bar__file {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .report-preview-actions-bar__input.p-inputtext,\n  .report-preview-actions-bar__buttons {\n    width: 100%;\n    max-width: none;\n  }\n\n  .report-preview-actions-bar__buttons .p-button {\n    flex: 1;\n  }\n}\n/* Compact ACM sidebar and report modal */\n.property-list-toolbar {\n  gap: var(--pl-ctrl-gap, 6px);\n  padding: 8px 10px;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);\n}\n\n.property-count-badge__legend,\n.property-count-badge__hint {\n  font-size: 10.5px;\n}\n\n.property-report-container .btn-generate-report {\n  min-height: var(--pl-ctrl-h, 36px);\n  padding: 0 0.75rem;\n  font-size: 0.75rem;\n}\n\n.acm-estimate-panel {\n  gap: 6px;\n  padding: 8px;\n}\n\n.acm-estimate-panel__header {\n  gap: 7px;\n}\n\n.acm-estimate-panel__icon {\n  flex-basis: 26px;\n  width: 26px;\n  height: 26px;\n  border-radius: 6px;\n  font-size: 12px;\n}\n\n.acm-estimate-panel__header p {\n  font-size: 0.6rem;\n}\n\n.acm-estimate-panel__header h3 {\n  font-size: 0.8rem;\n}\n\n.acm-estimate-panel__status {\n  padding: 3px 6px;\n  font-size: 0.6rem;\n}\n\n.acm-estimate-panel__main {\n  gap: 2px;\n  padding: 7px 8px;\n}\n\n.acm-estimate-panel__main strong {\n  font-size: 1.08rem;\n}\n\n.acm-estimate-panel__main span:last-child {\n  font-size: 0.68rem;\n}\n\n.acm-estimate-panel__alternatives {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 5px;\n}\n\n.acm-estimate-option {\n  min-height: 52px;\n  padding: 6px;\n  gap: 2px;\n}\n\n.acm-estimate-option span {\n  font-size: 0.58rem;\n}\n\n.acm-estimate-option strong {\n  font-size: 0.76rem;\n}\n\n.acm-estimate-option small,\n.acm-estimate-panel__details span:nth-child(n + 3) {\n  display: none;\n}\n\n.acm-estimate-panel__details {\n  gap: 4px;\n}\n\n.acm-estimate-panel__details span {\n  padding: 3px 6px;\n  font-size: 0.62rem;\n}\n\n.property-selection-guide--compact {\n  margin: 7px 10px 6px;\n  padding: 8px 30px 8px 9px;\n  box-shadow: none;\n}\n\n.property-selection-guide--compact .property-selection-guide__header {\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.property-selection-guide--compact .property-selection-guide__icon {\n  flex-basis: 28px;\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  font-size: 12px;\n}\n\n.property-selection-guide--compact .property-selection-guide__header p {\n  font-size: 0.58rem;\n}\n\n.property-selection-guide--compact .property-selection-guide__header h3 {\n  font-size: 0.78rem;\n}\n\n.property-selection-guide__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.property-selection-guide__chips span {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 6px;\n  border-radius: 999px;\n  color: #334155;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  font-size: 0.62rem;\n  font-weight: 700;\n}\n\n.property-list-scroll {\n  padding: 7px 10px 12px;\n  container: property-list / inline-size;\n  scrollbar-gutter: stable;\n  box-shadow: inset 0 8px 10px -12px rgba(15, 23, 42, 0.65);\n}\n\n.property-list-scroll::-webkit-scrollbar {\n  width: 10px;\n}\n\n.property-list-scroll::-webkit-scrollbar-track {\n  background: #f1f5f9;\n}\n\n.property-list-scroll::-webkit-scrollbar-thumb {\n  background: #fa7317;\n  border: 2px solid #f1f5f9;\n  border-radius: 999px;\n}\n\n.property-card {\n  display: grid;\n  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1fr);\n  gap: 10px;\n  max-width: 100%;\n  margin-bottom: 8px;\n  padding: 9px;\n  border-radius: 10px;\n}\n\n.property-thumbnail {\n  display: block;\n  width: 100%;\n  height: auto;\n  min-height: 0;\n  aspect-ratio: 4 / 3;\n  border-radius: 8px;\n}\n\n.property-card > .publication-details,\n.property-card > .property-actions {\n  grid-column: 1 / -1;\n  margin-top: 0;\n}\n\n@container property-list (max-width: 420px) {\n  .property-card {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.property-details {\n  gap: 4px;\n}\n\n.property-address {\n  font-size: 12.5px;\n  line-height: 1.28;\n  -webkit-line-clamp: 2;\n}\n\n.property-location {\n  font-size: 10.5px;\n}\n\n.property-list-scroll .property-price,\n.property-card .property-price {\n  font-size: 15px;\n  font-weight: 600;\n  margin-top: 0;\n}\n\n.expenses {\n  display: inline;\n  margin-left: 0;\n  font-size: 0.7em;\n}\n\n.property-meta {\n  font-size: 11.5px;\n}\n\n.property-amenities {\n  gap: 4px;\n}\n\n.property-amenity {\n  padding: 2px 6px;\n  font-size: 10px;\n}\n\n.property-actions {\n  gap: 5px;\n  padding-top: 7px;\n  margin-top: auto;\n}\n\n.property-card-action {\n  min-height: 30px;\n  font-size: 11px;\n}\n\n.report-preview-actions-bar {\n  padding: 6px 12px;\n}\n\n@media (max-width: 768px) {\n  .property-card {\n    gap: 8px;\n    padding: 8px;\n  }\n\n  .acm-estimate-panel__alternatives {\n    grid-template-columns: 1fr;\n  }\n\n  .acm-estimate-option small {\n    display: block;\n  }\n}\n.property-selection-guide__details {\n  margin-top: 7px;\n  border-top: 1px solid #e2e8f0;\n  padding-top: 7px;\n}\n\n.property-selection-guide__details summary {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #b45309;\n  font-size: 0.7rem;\n  font-weight: 800;\n  cursor: pointer;\n  list-style: none;\n}\n\n.property-selection-guide__details summary::-webkit-details-marker {\n  display: none;\n}\n\n.property-selection-guide__details summary i {\n  font-size: 0.78rem;\n}\n\n.property-selection-guide__details[open] summary {\n  margin-bottom: 6px;\n}\n\n.property-selection-guide__details ol {\n  margin: 0;\n  padding-left: 1.05rem;\n  color: #475569;\n  font-size: 0.72rem;\n  line-height: 1.35;\n}\n\n.property-selection-guide__details li + li {\n  margin-top: 0.18rem;\n}\n\n.property-selection-guide__details div {\n  margin-top: 6px;\n  padding: 6px 7px;\n  border-radius: 6px;\n  color: #0f766e;\n  background: #ecfdf5;\n  font-size: 0.7rem;\n  line-height: 1.3;\n}\n/* Report modal must fit viewport without clipping Hornero */\n.report-preview-dialog.p-dialog {\n  height: 96vh !important;\n  max-height: 96vh !important;\n}\n\n.report-preview-dialog .p-dialog-content {\n  height: 100% !important;\n  max-height: 100% !important;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden !important;\n}\n\n.report-preview-actions-bar {\n  flex: 0 0 auto;\n}\n\n.report-preview-workspace {\n  flex: 1 1 auto !important;\n  min-height: 0 !important;\n  height: auto !important;\n  max-height: none !important;\n  overflow: hidden !important;\n}\n\n.report-preview-workspace > aside,\n.report-preview-workspace > main {\n  min-height: 0 !important;\n  height: 100% !important;\n  max-height: none !important;\n}\n/* Use the actual dialog header for report guidance */\n.report-preview-dialog .p-dialog-header {\n  flex: 0 0 auto;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 8px 14px !important;\n  border-bottom: 1px solid #e2e8f0;\n  background: #fff;\n}\n\n.report-preview-dialog .p-dialog-title {\n  flex: 1;\n  min-width: 0;\n}\n\n.report-preview-dialog .p-dialog-header-icons {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.report-preview-modal-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  min-width: 0;\n}\n\n.report-preview-modal-header__badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  padding: 4px 7px;\n  border-radius: 6px;\n  color: #c2410c;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  font-size: 0.64rem;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.report-preview-modal-header__content {\n  min-width: 0;\n}\n\n.report-preview-modal-header__content h2 {\n  margin: 0;\n  color: #0f172a;\n  font-size: 0.95rem;\n  line-height: 1.15;\n  letter-spacing: 0;\n}\n\n.report-preview-modal-header__content p {\n  margin: 2px 0 0;\n  color: #475569;\n  font-size: 0.74rem;\n  line-height: 1.25;\n}\n\n.report-preview-modal-header__branding {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 5px;\n  color: #7c2d12;\n  font-size: 0.7rem;\n  line-height: 1.2;\n}\n\n.report-preview-modal-header__branding i {\n  color: #ea580c;\n  font-size: 0.78rem;\n  flex-shrink: 0;\n}\n\n.report-preview-modal-header__branding span {\n  min-width: 0;\n}\n\n.report-preview-modal-header__branding a {\n  color: #c2410c;\n  font-weight: 800;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.report-preview-modal-header__branding a:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 780px) {\n  .report-preview-modal-header,\n  .report-preview-modal-header__branding {\n    flex-wrap: wrap;\n  }\n}\n.property-publisher {\n  display: flex;\n  align-items: baseline;\n  gap: 5px;\n  margin: 2px 0 0;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n.property-publisher i { flex-shrink: 0; font-size: 11px; }\n.property-publisher__name {\n  color: #1e293b;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
